var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row soloTexto"},_vm._l((_vm.seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb),function(contenidoDeLaPaginaWeb){return _c('span',{key:contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId,staticClass:"text-justify"},[_vm._v(_vm._s(contenidoDeLaPaginaWeb.TextoDelContenido))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc9dabd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginaOficial/PaginaInformativa/Formatos/SoloTexto.vue
// module id = null
// module chunks = 